import React from 'react'
import { ImageContainer, BackgroundImage, ContentOverlay, Title, SubTitle } from '../styles/BackgroundImageStyle'
import {
  SectionContainer,
  GridContainer,
  PropertyCard,
  ImageCardContainer,
  PropertyImage,
  Badge,
  CardContent,
  TitleLink,
  Heading,
  Address,
  Features,
  FeatureSeparator,
  Price,
} from '../styles/ListFeaturedPropertiesStyles.js'

const properties= [
  {
    id: 1,
    image: "/assets/images/fe1.jpg",
    badge: "For Sale",
    title: "3910 Berryman Ave",
    address: "3910 Berryman Ave, Los Angeles, CA, 90066",
    features: {
      bedrooms: "4BD",
      bathrooms: "5BA",
      area: "2,608 Sq.Ft."
    },
    price: "$2,750,000"
  },
  {
    id: 2,
    image: "/assets/images/fe2.jpg",
    badge: "For Rent",
    title: "125 Ocean Blvd",
    address: "125 Ocean Blvd, Miami, FL, 33139",
    features: {
      bedrooms: "3BD",
      bathrooms: "2BA",
      area: "1,850 Sq.Ft."
    },
    price: "$3,500/month"
  },
  {
    id: 3,
    image: "/assets/images/fe3.jpg",
    badge: "Sold",
    title: "7825 Elmwood Ave",
    address: "7825 Elmwood Ave, Dallas, TX, 75235",
    features: {
      bedrooms: "5BD",
      bathrooms: "4BA",
      area: "3,200 Sq.Ft."
    },
    price: "$1,850,000"
  }
]

const ListFeaturedProperties = () => {
  return (
    <div>
        <ImageContainer>
                {/* Background Image */}
                <BackgroundImage
                src="/assets/images/inTheNews.jpg"
                alt="background-image"
                />
                {/* Content Overlay */}
                <ContentOverlay>
                <Title>Featured Properties</Title>
                <SubTitle>Browse our current listings online or contact us for further information.</SubTitle>
                </ContentOverlay>
        </ImageContainer>
        

        {/* Featured Properties */}
        <SectionContainer>
          <GridContainer>
            {properties.map((property) => (
              <PropertyCard key={property.id}>
                {/* Property Image */}
                <ImageCardContainer>
                  <PropertyImage src={property.image} alt={property.title} />
                  <Badge>{property.badge}</Badge>
                </ImageCardContainer>

                {/* Property Details */}
                <CardContent>
                  <TitleLink href="#home">
                    <Heading>{property.title}</Heading>
                  </TitleLink>
                  <Address>{property.address}</Address>
                  <Features>
                    {property.features.bedrooms} |{' '}
                    <FeatureSeparator>{property.features.bathrooms}</FeatureSeparator> |{' '}
                    <FeatureSeparator>{property.features.area}</FeatureSeparator>
                  </Features>
                  <Price>{property.price}</Price>
                </CardContent>
              </PropertyCard>
            ))}
          </GridContainer>
        </SectionContainer>
    </div>
  )
}

export default ListFeaturedProperties